// extracted by mini-css-extract-plugin
export default {"recentSearchesHeader":"VeFMCUa sY3mB1c london3-button","recentSearchesClearButton":"uCHdSRx rhsKrX3 sY3mB1c london3-button"};